function loadBackgroundImages() {
    $('.bg-image').each(function() {
        $(this).css("background-image", 'url(' + $(this).data("bgimage") + ')');
    });
}